import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, useField } from 'formik';
import {
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  FormHelperText,
} from '@material-ui/core';

SelectInput.propTypes = {};

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
    '& .MuiFilledInput-root': {
      borderRadius: theme.spacing(0.5),
      '&.Mui-error': {
        '& .MuiFilledInput-input': {
          border: '1px solid red',
        },
      },
    },
  },
  select: {
    // To override the global SAS styles
    borderRadius: theme.spacing(0.5),
    '&.MuiSelect-select': {
      '&:focus-within': {
        boxShadow: '0 0 0 2px #ffffff,0 0 0 4px #0159ce',
      },
      '&:active': {
        backgroundImage: 'unset',
      },
      '&:hover': {
        backgroundColor: '#eae9e8',
      },
    },
    '&.MuiInputLabel-filled': {
      borderRadius: theme.spacing(0.5),
    },
    '&.MuiFilledInput-input': {
      borderRadius: theme.spacing(0.5),
      border: '1px solid #d5d4d1',
      backgroundColor: '#ffffff',
    },
  },
}));

function SelectInput({ label, name, required, optionsData, ...props }) {
  const classes = useStyles();
  const { isSubmitting } = useFormikContext();
  const [field, meta, { setValue }] = useField(name);

  const fieldError = meta.error;
  const showError = !!fieldError;

  return (
    <FormControl
      variant="filled"
      className={classes.formControl}
      required={required}
      error={showError}
    >
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        native
        fullWidth
        label={label}
        inputProps={{
          name,
          id: name,
        }}
        disableUnderline
        {...field}
        {...props}
        classes={{ select: classes.select }}
      >
        <option aria-label="None" value="" />
        {optionsData &&
          optionsData.map(({ code, name }, index) => (
            <option key={index} value={code}>
              {name}
            </option>
          ))}
      </Select>
      <FormHelperText>{fieldError}</FormHelperText>
    </FormControl>
  );
}

export default SelectInput;
